import { ComplexValue } from 'app/types-shared';

export const revertValueItems = (valueItems: ComplexValue<number>[], options: ComplexValue<number>[]) => {

  return options && options.filter(option => !valueItems || !valueItems.some(item => item.value === option.value))
    || [];
};
